import { render } from "./CouplesPage.vue?vue&type=template&id=70a90419&scoped=true"
import script from "./CouplesPage.vue?vue&type=script&lang=js"
export * from "./CouplesPage.vue?vue&type=script&lang=js"

import "./CouplesPage.vue?vue&type=style&index=0&id=70a90419&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a90419"]])

export default __exports__